(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Wholesale Sidebar functionality
  class WholesaleSidebar {
    constructor() {
      this.sidebar = document.getElementById('wholesale-sidebar');
      this.closeButton = this.sidebar?.querySelector('.wholesale-sidebar__close');
      this.overlay = this.sidebar?.querySelector('.wholesale-sidebar__overlay');
      
      this.init();
    }

    init() {
      if (!this.sidebar) return;

      // Add click event to wholesale links
      this.addWholesaleLinkListeners();
      
      // Add close functionality
      this.closeButton?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());
      
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.sidebar.classList.contains('active')) {
          this.close();
        }
      });

      // Prevent body scroll when sidebar is open
      this.sidebar.addEventListener('transitionend', () => {
        if (this.sidebar.classList.contains('active')) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
    }

    addWholesaleLinkListeners() {
      console.log('Setting up wholesale sidebar listeners...');
      
      // Method 1: Find all navigation links and check for "wholesale" text
      const allNavLinks = document.querySelectorAll('.header__menu-item, .menu-drawer__menu-item');
      console.log('Found nav links:', allNavLinks.length);
      
      allNavLinks.forEach((link, index) => {
        console.log(`Link ${index}:`, link.textContent.trim());
        // Check if the link text contains "wholesale" (case insensitive)
        if (link.textContent.toLowerCase().trim().includes('wholesale')) {
          console.log('Found wholesale link:', link.textContent.trim());
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.open();
          });
        }
      });

      // Method 2: Also check all links in the header area as a fallback
      const headerLinks = document.querySelectorAll('header a');
      console.log('Found header links:', headerLinks.length);
      
      headerLinks.forEach((link, index) => {
        console.log(`Header link ${index}:`, link.textContent.trim());
        if (link.textContent.toLowerCase().trim().includes('wholesale')) {
          console.log('Found wholesale header link:', link.textContent.trim());
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.open();
          });
        }
      });

      // Method 3: Use event delegation for dynamic content
      document.addEventListener('click', (e) => {
        const target = e.target.closest('a');
        if (target && target.textContent.toLowerCase().trim().includes('wholesale')) {
          console.log('Wholesale link clicked via delegation:', target.textContent.trim());
          e.preventDefault();
          e.stopPropagation();
          this.open();
        }
      });

      // Method 4: Global click handler as ultimate fallback
      document.addEventListener('click', (e) => {
        // Check if clicked element or its parent is a link with "wholesale" text
        let element = e.target;
        while (element && element !== document.body) {
          if (element.tagName === 'A' && element.textContent.toLowerCase().trim().includes('wholesale')) {
            console.log('Wholesale link clicked via global handler:', element.textContent.trim());
            e.preventDefault();
            e.stopPropagation();
            this.open();
            return;
          }
          element = element.parentElement;
        }
      });
    }

    open() {
      if (this.sidebar) {
        // Set a very high z-index to ensure it's above everything
        this.sidebar.style.zIndex = '999999';
        
        // Add class to body to hide elements
        document.body.classList.add('wholesale-sidebar-open');
        
        // Hide any elements that might be above the sidebar
        this.hideElementsAboveSidebar();
        
        // Show overlay immediately
        this.overlay.style.opacity = '1';
        this.overlay.style.visibility = 'visible';
        
        this.sidebar.classList.add('active');
        
        // Focus the close button for accessibility
        setTimeout(() => {
          this.closeButton?.focus();
        }, 300);
      }
    }

    hideElementsAboveSidebar() {
      // Find and hide elements that might appear above the sidebar
      const elementsToHide = [
        '.shopify-section-group-header-group', // Announcement bar
        '.announcement-bar-section',
        '.utility-bar',
        '.header-wrapper',
        '.header'
      ];

      elementsToHide.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (element) {
            element.style.zIndex = '1';
            element.style.position = 'relative';
          }
        });
      });
    }

    close() {
      if (this.sidebar) {
        this.sidebar.classList.remove('active');
        document.body.style.overflow = '';
        document.body.classList.remove('wholesale-sidebar-open');
        
        // Hide overlay
        this.overlay.style.opacity = '0';
        this.overlay.style.visibility = 'hidden';
        
        // Restore original z-index values
        this.restoreOriginalZIndex();
      }
    }

    restoreOriginalZIndex() {
      // Restore original z-index values for elements
      const elementsToRestore = [
        '.shopify-section-group-header-group',
        '.announcement-bar-section', 
        '.utility-bar',
        '.header-wrapper',
        '.header'
      ];

      elementsToRestore.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (element) {
            element.style.zIndex = '';
            element.style.position = '';
          }
        });
      });
    }
  }

  // Initialize the wholesale sidebar when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new WholesaleSidebar();
    initFloatingLabels();
  });

  // Also initialize after a short delay to catch any dynamically loaded content
  setTimeout(() => {
    if (!window.wholesaleSidebar) {
      window.wholesaleSidebar = new WholesaleSidebar();
    }
    initFloatingLabels();
  }, 1000);

  // Initialize floating labels
  function initFloatingLabels() {
    const inputGroups = document.querySelectorAll('.wholesale-sidebar__input-group');
    
    inputGroups.forEach(group => {
      const input = group.querySelector('input');
      const label = group.querySelector('label');
      
      if (input && label) {
        // Don't auto-float labels on page load, even if they have values
        // Only float when user actually interacts with the field
        
        // Handle focus events
        input.addEventListener('focus', () => {
          label.classList.add('floating');
        });
        
        // Handle blur events
        input.addEventListener('blur', () => {
          if (!input.value || input.value.trim() === '') {
            label.classList.remove('floating');
          }
        });
        
        // Handle input events
        input.addEventListener('input', () => {
          if (input.value && input.value.trim() !== '') {
            label.classList.add('floating');
          } else {
            label.classList.remove('floating');
          }
        });
      }
    });
  }



  

  } catch(e) { console.error(e); }
})();
})();
